export const colorNoFocus = "#777";
export const colorFocus = "#1C1C1C";
export const colorDisabled = "#bbb";
export const colorBorderDisabled = "rgba(0, 0, 0, 0.42)";
export const colorHover = "#1C1C1C";
export const colorClearNormal = "#ff4040";
export const colorClearHover = "#d00000";
export const colorError = "#F44336";
